import styled from 'styled-components';

export const UberEatsImage = styled.img`
  display: block;
  max-width: 400px;
  width: 100%;
  margin: 0 auto;
`;

export default UberEatsImage;
